/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const fetchMyBenefitsHCM = createAsyncThunk(
  'fetchMyBenefitsHCM',
  async (params) => {
    const jwtToken = localStorage.getItem('myrJwtToken')
    const rcpid = localStorage.getItem('rcpid')
    const res = await axios.get(
      `${process.env.REACT_APP_MYBENEFITS_TWO_ENDPOINT}?PersonNumber=${params.personNumber}`,
      {
        headers: {
          JWT: jwtToken,
          XWT: rcpid,
        },
      },
    )
    return res.data
  },
)

const initialState = {
  status: 'idle',
  data: {
    title: 'My Benefits',
    summary: [],
    links: [],
  },
}

const myBenefitsHCMSlice = createSlice({
  name: 'myBenefitsSliceHCM',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchMyBenefitsHCM.rejected]: (state) => {
      state.status = 'error'
    },
    [fetchMyBenefitsHCM.pending]: (state) => {
      state.status = 'pending'
    },
    [fetchMyBenefitsHCM.fulfilled]: (state, action) => {
      state.status = 'fulfilled'
      state.data = action.payload
    },
  },
})

export const selectMyBenefitsHCMData = (state) => state.myBenefitsHCM.data
export const selectMyBenefitsHCMStatus = (state) => state.myBenefitsHCM.status

export default myBenefitsHCMSlice.reducer
